import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qa8gaqqvwt: FaireBrandEntity = {
  token: "b_qa8gaqqvwt",
  type: "brand",
  name: "Vitality",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c841250bea726096f920b331dbd6b057263fb9fa898196e69dc6931218fb497.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/68e7989656a7b2086ad1bfacba823035e5de2cd349ef2d74c1a044ccf931b7f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7c841250bea726096f920b331dbd6b057263fb9fa898196e69dc6931218fb497.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/68e7989656a7b2086ad1bfacba823035e5de2cd349ef2d74c1a044ccf931b7f0.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 693,
  rating: 5,
  reviewCount: 11,
  isTopShop: true,
  isInsider: true,
  description:
    "We make athleisure. Really well. We’re super good at it. Just check out our +125k five-star reviews . Our fabrics will blow your mind. We make things fit to make you feel powerful. We design meticulously so that can get dressed effortlessly. We understand the under. Not just one size, all sizes, and we’ve done it from the start. Extended size runs were a rarity in 2018 … so we did something about it. More than fabrics. More than fitness. Vitality is a feeling. A way of life. A moment to savor. A force of nature. Where you feel good and look good doing it. Where sweat meets serenity. Find yours. Find Vitality.\n\nVitality fabrics are made with recycled and reclaimed materials, dyed using a water-conserving, zero-waste method, and manufactured at ecological award-winning facilities that employ solar power, energy-efficient machinery, and advanced water-conservation and carbon-reduction practices.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.209Z",
    importedBy: "entity-db-cli",
  },
};
